$(function () {
  $(document).on('click', '#btn-add-guest', function () {
    const sessionId = $(this).data('session-id');
    $.ajax({
      type: 'POST',
      url: '/api/v1/private/table-guests/add',
      data: { session_id: sessionId },
      success: function (response) {
        const { data, message, status } = response;
        if (data.html !== undefined && data.html !== null) {
          $('#guest-chips').append(data.html);

          updateCanRemoveGuestState();

          showToast({
            type: 'success',
            message: message,
            autoHide: true,
            position: 'top-right',
            delay: 1500,
          });
        }
      },
      error: function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    });
  });

  $(document).on('click', '#guestAddBtn', function () {
    const sessionId = $(this).attr('data-session-id');
    const guestName = $('#guestNameInput').val().trim();
    const tableId = $(this).attr('data-table-id');
    const tableName = $(this).attr('data-table-name');

    if (guestName === '') {
      showToast({
        type: 'error',
        message: 'Gjestenavn kan ikke være tomt.',
        autoHide: true,
        position: 'top-right',
        delay: 1500,
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/table-guests/add',
      data: {
        session_id: sessionId,
        guest_name: guestName,
        tableId,
        products: locationCart.products,
        orderComment: locationCart.comment,
      },
      success: function (response) {
        const { data } = response;

        if (sessionId && data.html !== undefined && data.html !== null) {
          $('#guestList').append(data.html);
          $('#guestNameInput').val('');
        } else {
          const totalAmount = locationCart.products.reduce(
            (sum, product) =>
              sum +
              product.original_product_price *
                (1 - product.discount_percent / 100) *
                product.amount,
            0
          );

          const isPayNow = openTablePayNowCheckout(
            data.sessionId,
            data.guestId
          );

          showToast({
            type: 'success',
            message: isPayNow
              ? `Sendt til ${tableName} – går til betaling`
              : `Sum ${floor(totalAmount)} og ${locationCart.number_of_products} varer satt på ${tableName}`,
            position: 'bottom-right',
            duration: 1500,
          });

          $('#table-guest-modal').modal('hide');
          $('#table-sessions-modal').modal('hide');
          if (!isPayNow) {
            emptyAllCart();
          }
        }
      },
      error: function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      },
    });
  });
});

function updateCanRemoveGuestState() {
  if ($('.js-rm-guest').length > 1) {
    $('.js-rm-guest').removeClass('d-none').addClass('d-flex');
  } else if ($('.js-rm-guest').length === 1) {
    $('.js-rm-guest').removeClass('d-flex').addClass('d-none');
  }
}
